import './ModalHeader.scss';

import H2 from 'components/H2';
import React from 'react';

export default class ModalHeader extends React.Component {
    render() {
        return (
            <header className="modal__header">
                <H2>
                {this.props.children}
                </H2>
            </header>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalHeader/index.js